export const Input = `
  <Input 
    label="Label"
    type="text"
    value="Any Value"
    name="my-input-text"
    id="custom-id"
    onChange={handleChange}
    placeholder="Name"
    className="custom-class-name"
    isInvalid={true}
    isInvalidText="Please enter a valid name"
    maxLength={50}
    disabled={false}
  />
`
